"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.copy = exports.remove = exports.list = exports.getUrl = exports.getProperties = void 0;
var getProperties_1 = require("./getProperties");
Object.defineProperty(exports, "getProperties", { enumerable: true, get: function () { return getProperties_1.getProperties; } });
var getUrl_1 = require("./getUrl");
Object.defineProperty(exports, "getUrl", { enumerable: true, get: function () { return getUrl_1.getUrl; } });
var list_1 = require("./list");
Object.defineProperty(exports, "list", { enumerable: true, get: function () { return list_1.list; } });
var remove_1 = require("./remove");
Object.defineProperty(exports, "remove", { enumerable: true, get: function () { return remove_1.remove; } });
var copy_1 = require("./copy");
Object.defineProperty(exports, "copy", { enumerable: true, get: function () { return copy_1.copy; } });
